import React from "react"
import styled from "styled-components"
import { FullSlider } from "@omnichannel/ace-b2b-elements"
import { useStaticQuery, graphql, navigate } from "gatsby"
import useWindowDimensions from "../helpers/windowDimensions"
import withApolloClient from "./withApolloClient"
import { useQuery } from "@apollo/react-hooks"
import { gql } from "apollo-boost"
import PostBanner from "./postBanner"

const Banner = styled.img`
  display: block;
  height: auto;
  width: 100%;
  /* @media (min-width: 768px) {
    width: 100%;
    height: 398px;
    display: inline;
    object-fit: cover;
  } */
  @media (min-width: 768px) {
    width: 100%;
    height: 420px;
    display: inline;
    object-fit: cover;
  }
  @media (min-width: 900px) {
    width: 100%;
    height: 470px;
    display: inline;
    object-fit: cover;
  }
  @media (min-width: 1051px) {
    width: 100%;
    height: 398px;
    display: inline;
    object-fit: cover;
  }
`

const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: auto;
  cursor: ${props => (props.url ? "pointer" : "initial")};
  @media (min-width: 768px) {
    justify-content: center;
  }
`

function HeaderBanner(props) {
  const { width } = useWindowDimensions()
  const { data } = useQuery(gql`
    query BannerQuery {
      getHeaderBanners {
        _id
        base64
        base64_mobile
        url
        subBanners
      }
    }
  `)

  return (
    <>
      {data && (
        <FullSlider slides={1} autoplay infinite dots

          dotsBottomOffset="0.4rem"
          dotsActiveColor="#000"
          // dotsActiveColor="#FFF"
          dotsPassiveColor="#000"
          dotsFontSize="1rem"
        >
          {data &&
            data.getHeaderBanners.map((banner, index) => {
              const showBanner =
                width > 1050
                  ? banner.base64
                  : banner.base64_mobile || banner.base64
              return (
                <BannerContainer
                  url={banner.url}
                  key={banner._id}
                  onClick={() => navigate(banner.url)}
                >
                  <Banner src={showBanner} key={index} draggable={false} />
                </BannerContainer>
              )
            })}
        </FullSlider>
      )}
      {/* <PostBanner /> */}
    </>
  )
}

export default withApolloClient(HeaderBanner, {
  client: "smClient",
})
